export interface ISortOption {
    id: string;
    labelKey: string;
}

export type IndustrySortType = "last_seen" | "first_seen" | "active_days";

export const WEBSITE_SORT_OPTIONS: ISortOption[] = [
    { id: "lastseen", labelKey: "ad.intelligence.advertiser.ad.widget.filter.last.seen" },
    { id: "duration", labelKey: "ad.intelligence.advertiser.ad.widget.filter.duration" },
];

export const INDUSTRY_SORT_OPTIONS: ISortOption[] = [
    { id: "last_seen", labelKey: "ad.intelligence.advertiser.ads.last.seen.column.title" },
    { id: "first_seen", labelKey: "ad.intelligence.advertiser.ads.first.seen.column.title" },
    { id: "active_days", labelKey: "ad.intelligence.advertiser.ads.activeDays.title" },
];
